/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum OrderType {
    ABOVE = 'above',
    BELOW = 'below',
}
